import { useTranslation } from 'react-i18next'
import { motion } from 'motion/react'
import mockupBirkenhof from '../assets/mockup-birkenhof.webp'

export default function Intro() {
  const { t } = useTranslation()

  return (
    <section id="intro" className="bg-sand py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-stretch">
        {/* Left – Text */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        >
          <p className="font-body text-rot text-xs tracking-widest uppercase mb-3">
            {t('intro.kicker')}
          </p>
          <h2 className="font-headline text-espresso text-4xl md:text-5xl leading-tight mb-4">
            {t('intro.h2line1')}
          </h2>
          {t('intro.h2line2') && (
            <h2 className="font-headline text-espresso text-2xl md:text-3xl leading-tight mb-4">
              {t('intro.h2line2')}
            </h2>
          )}
          <p className="font-headline text-rot text-2xl mb-8">{t('intro.subheadline')}</p>
          <p className="font-body text-espresso/80 text-base leading-relaxed mb-4 max-w-2xl">
            {t('intro.p1')}
            {t('intro.p2') ? ' ' + t('intro.p2') : ''}
          </p>
          {t('intro.p3') && (
            <p className="font-body text-espresso/80 text-base leading-relaxed mb-10 max-w-2xl">
              {t('intro.p3')}
            </p>
          )}
          {!t('intro.p3') && <div className="mb-10" />}
          <a
            href="#team"
            className="bg-rot text-sand rounded-full px-8 py-3 inline-block font-body hover:bg-lachs transition-colors"
          >
            {t('intro.button')}
          </a>
        </motion.div>

        {/* Right – Intro image */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
          className="flex justify-end items-center"
        >
          <div className="w-full rounded-xl overflow-hidden shadow-md">
            <img
              src={mockupBirkenhof}
              alt="buenas studio – good. better. buenas."
              loading="lazy"
              width={4458}
              height={2972}
              className="w-full h-full object-cover"
            />
          </div>
        </motion.div>
      </div>
    </section>
  )
}
